import { useServices } from "@core/servicesContext";
import { PaginatedDataResult, usePaginatedStore } from "@utils/hooks";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { NotificationFilter, TooshareNotification } from "./notification";

export function useNotifications(): PaginatedDataResult<TooshareNotification, { unread: number }> {
	const { notificationService } = useServices();
	const currentProfile = useCurrentProfile();
	return usePaginatedStore(notificationService.notificationStore, [currentProfile?.id]);
}

export function useNotificationsSettings(): PaginatedDataResult<NotificationFilter> {
	const { notificationService } = useServices();
	const currentProfile = useCurrentProfile();
	return usePaginatedStore(notificationService.notificationSettingsStore, [currentProfile?.id]);
}
